import React from "react";
import style from "../signin.module.css";
import googleLogo from "../../assets/icons/google.svg";
import {cacheService} from "../../../services/cacheService";
import apiService from "../../../services/apiServices";
import {GoogleLogin, GoogleOAuthProvider} from "@react-oauth/google";
import {useNavigateTo} from "../../../helpers/navigateTo";
import {clearCache} from "../../../helpers/clearCache";

const LoginWithGoogle = () => {
    const GOOGLECLIENTID = "1025891271764-mmvijafb4dc1d3gclpq117om5h8al8ub.apps.googleusercontent.com";
    const {navigateTo} = useNavigateTo();

    const setGoogleLogin = async (res) => {
        try {
            const response = await responseGoogle(res);
            const {token, public_id} = response.data.data;
            const alternateGuest = cacheService.get("AlternateGuest");
            clearCache();

            cacheService.set("Id", public_id);
            cacheService.set("Authorization", `Token ${token}`);
            if (!!alternateGuest) {
                navigateTo({pathname: `/dashboard/${alternateGuest}`}, {replace: true});
                cacheService.set("AlternateGuest", "");
            } else {
                // if (is_registered) {
                    navigateTo({pathname: "/dashboard", search: "?%signIn"})
                // } else {
                //     navigateTo({pathname: "/profile", search: "?%signUp"});
                // }
            }

        } catch (e) {
            console.warn("ERROR: ", e.message);
        }
    };

    const responseGoogle = (response) => apiService.setGoogleLoginToken({
        "auth_token": response.credential,
    });

    return (
            <GoogleOAuthProvider clientId={GOOGLECLIENTID}>
                <div className="google-login-wrapper">
                    <GoogleLogin
                        onSuccess={response => {
                            void setGoogleLogin(response);
                        }}
                        onError={() => {
                            console.log("Login Failed");
                        }}
                    />
                </div>
                <button className={style.social_btn}>
                    <img className={style.social_img} src={googleLogo} alt="google"/>
                </button>
            </GoogleOAuthProvider>
    )
}

export default LoginWithGoogle;